import React from "react";
import { Field } from "redux-form";
import { Typography } from "@mui/material";
import { CustomCheckbox } from "../../../../../../common/customCheckbox";

import localStyles from "./DefaultHighRiskActivitiesSection.module.css";

export default function DefaultHighRiskActivitiesSection({ sectionKey, sectionData, loading }) {
  const rows = Array.isArray(sectionData && sectionData.data) ? sectionData.data : [];

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          {rows.length === 0 ? (
            <div>
              <Typography textAlign="center" className={localStyles.EmptyStateText}>No high risk activities available.</Typography>
            </div>
          ) : (
            <div className={localStyles.CardGrid}>
              {rows.map((category, catIndex) => {
                const activities = Array.isArray(category && category.activities) ? category.activities : [];

                return (
                  <div
                    key={`${category && category.category_name ? category.category_name : "cat"}-${catIndex}`}
                    className={localStyles.CategoryCard}
                  >
                    <div
                      className={localStyles.CategoryHeader}
                      style={{ backgroundColor: category && category.category_color ? category.category_color : "#6f6485" }}
                    >
                      <Typography className={localStyles.CategoryTitle}>
                        {category && category.category_name ? category.category_name : "Category"}
                      </Typography>
                    </div>

                    <div className={localStyles.CardBody}>
                      {activities.length === 0 ? (
                        <div>
                          <Typography textAlign="center" className={localStyles.EmptyStateText}>
                            No activities available in this category.
                          </Typography>
                        </div>
                      ) : (
                        activities.map((activity, activityIndex) => (
                          <div
                            key={`${activity && activity.id ? activity.id : "activity"}-${activityIndex}`}
                          >
                            <Field
                              component={CustomCheckbox}
                              name={`${catIndex}.activities.${activityIndex}.selected`}
                              disabled={loading}
                              label={activity && activity.activity_name ? activity.activity_name : "Unnamed activity"}
                              className="cs-select-v2"
                            />
                          </div>
                        ))
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>

      </div>
    </div>
  );
}
